<template>
  <v-app>

    <div>
      {{ $t('User course') }}
      <div :key="course.id" v-for="course in courses">
        <div class="text-h5 text-decoration-underline">{{course.title}}</div>
        <p>Tags: {{course.tags.map(tag => tag.name).join(', ') }}</p>
        <img :src="imageUrl(course)">
        <div class="ml-2" :key="chapter.id" v-for="chapter in course.chapters">
          <div class="text-h6">{{chapter.chapter.title}}({{chapter.aliasTitle}} / {{chapter.startDate}})</div>
          <a v-if="chapter.chapter.content" :href="downloadUrl(chapter.chapter.content)">Kapitelinhalt</a>
          <div class="ml-4" :key="lesson.id" v-for="lesson in chapter.chapter.lessons">
            <div class="text-h6">{{lesson.lesson.title}}({{lesson.aliasTitle}})</div>
            <a v-if="lesson.lesson.content" :href="downloadUrl(lesson.lesson.content)">Lektionsinhalt</a>
          </div>
        </div>
      </div>
      <Spinner v-if="showLoader" class="s3m-spinner" name="circle" color="#008bc4" />
    </div>
  </v-app>
</template>

<script>
import APIService from "@/services/APIService";

export default {
  name: "UserCourses",
  data() {
    return {
      courses: [],
      showLoader: false
    }
  },
  methods: {
    downloadUrl(content) {
      return content.length > 0 ? `${process.env.VUE_APP_ROOT_API}/content/${content[0].path}` : ''
    },
    imageUrl(course) {
      return course.image ? `${process.env.VUE_APP_ROOT_API}/content/${course.image.path}` : ''
    },
    async loadCourses(userId) {
      this.showLoader = true
      try {
        this.courses = await APIService.getUserCourses(userId)
      } finally {
        this.showLoader = false
      }
    }
  },

  async beforeRouteEnter(to, from, next) {
    next(vm => vm.loadCourses(to.params.userId))
  },
  async beforeRouteUpdate(to, from, next) {
    await this.loadCourses(to.params.userId)
    next()
  }
}
</script>

<style scoped>
  img {
    max-width: 200px;
  }
</style>
